import { render, staticRenderFns } from "./Packages.vue?vue&type=template&id=0f9a6d6c&scoped=true&"
import script from "./Packages.vue?vue&type=script&lang=js&"
export * from "./Packages.vue?vue&type=script&lang=js&"
import style0 from "./Packages.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Packages.vue?vue&type=style&index=1&id=0f9a6d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9a6d6c",
  null
  
)

export default component.exports